$('.user-prize-import #form_prize').on('change init', function () {
    let selectedValue = $(this).find('option:selected').val();
    $('.user-prize-import #form_reserve').parent().parent().toggleClass('d-none', !selectedValue);
    $('.user-prize-import .prizes-info').toggleClass('d-none', !!selectedValue);
}).trigger('init');